import { useCallback, useState } from 'react';

export type ToggleResult = [boolean, () => void, () => void];

export function useToggle(defaultValue: boolean = false): ToggleResult {
    const [isOpen, setOpen] = useState<boolean>(defaultValue);

    const setTruthy = useCallback(() => {
        setOpen(true);
    }, []);

    const setFalsy = useCallback(() => {
        setOpen(false);
    }, []);

    return [isOpen, setTruthy, setFalsy];
}
